export default __webpack_public_path__ + "static/media/detection.494cdab5.csv";